import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

import { ConfigService } from '../config/config-service';
import { SessionService } from './session.service';

@Injectable()
export class TransferenciasService {
  private config: ConfigService;
	private _token: any;
	private host_api: String;
	private dbname: string;

  constructor(
		private http: Http,
		private ss: SessionService,
	) {
		this.config = new ConfigService();
		this.host_api = this.ss.getData('host_api');
		this._token = sessionStorage.getItem('api-token');
		this.dbname = this.ss.getData('dbname');
    }
    

  	getAll(queryString: String = "") {
      let url = this.host_api + '/transferencia' + queryString;
      let headers = new Headers({ 'Accept': 'application/json' });
      headers.append('Authorization', "Bearer "+ this._token);
      headers.append('dbname', this.dbname);
      let options = new RequestOptions({ headers: headers });
  
      return this.http.get(url, options).map((res: Response) => {
        return this.config.onSuccessResponse(res);
      }).catch((error: any) => {
        return this.config.onErrorResponse(error);
      });
    }

    getByFilter(queryString: String = "") {
      let url = this.host_api + '/transferencia/filter' + queryString;
      let headers = new Headers({ 'Accept': 'application/json' });
      headers.append('Authorization', "Bearer "+ this._token);
      headers.append('dbname', this.dbname);
      let options = new RequestOptions({ headers: headers });
  
      return this.http.get(url, options).map((res: Response) => {
        return this.config.onSuccessResponse(res);
      }).catch((error: any) => {
        return this.config.onErrorResponse(error);
      });
    }

    getDetalles(queryString: String = "") {
      let url = this.host_api + '/transferencia/detalles' + queryString;
      let headers = new Headers({ 'Accept': 'application/json' });
      headers.append('Authorization', "Bearer "+ this._token);
      headers.append('dbname', this.dbname);
      let options = new RequestOptions({ headers: headers });
  
      return this.http.get(url, options).map((res: Response) => {
        return this.config.onSuccessResponse(res);
      }).catch((error: any) => {
        return this.config.onErrorResponse(error);
      });
    }
  
    getById(id, qs: String) {
      let url = this.host_api + '/transferencia/' + id + qs;
      let headers = new Headers({ 'Accept': 'application/json' });
      headers.append('Authorization', "Bearer "+ this._token);
      headers.append('dbname', this.dbname);
      let options = new RequestOptions({ headers: headers });
  
      return this.http.get(url, options).map((res: Response) => {
        return this.config.onSuccessResponse(res);
      }).catch((error: any) => {
        return this.config.onErrorResponse(error);
      });
    }

    getBySearch(queryString: String = "") {
      let url = this.host_api + '/transferencia/search' + queryString;
      let headers = new Headers({ 'Accept': 'application/json' });
      headers.append('Authorization', "Bearer "+ this._token);
      headers.append('dbname', this.dbname);
      let options = new RequestOptions({ headers: headers });
  
      return this.http.get(url, options).map((res:Response) => {	
        return this.config.onSuccessResponse(res);
      }).catch((error: any) => {
        return this.config.onErrorResponse(error);
      });		
    }
  
    save(transferencia) {
      let url = this.host_api + '/transferencia';
      let params = transferencia;
      let headers = new Headers({ 'Content-type': 'application/json' });
      headers.append('Authorization', "Bearer "+ this._token);
      headers.append('dbname', this.dbname);
      let options = new RequestOptions({ headers: headers });
  
      return this.http.post(url, params, options).map((res: Response) => {
        return this.config.onSuccessResponse(res);
      }).catch((error: any) => {
        return this.config.onErrorResponse(error);
      });
    }
  
    update(transferencia) {
      let url = this.host_api + '/transferencia/' + transferencia.id;
      let params = JSON.stringify(transferencia);
      let headers = new Headers({ 'Content-type': 'application/json' });
      headers.append('Authorization', "Bearer "+ this._token);
      headers.append('dbname', this.dbname);
      let options = new RequestOptions({ headers: headers });
  
      return this.http.put(url, params, options).map((res: Response) => {
        return this.config.onSuccessResponse(res);
      }).catch((error: any) => {
        return this.config.onErrorResponse(error);
      });
    }
  
    delete(id) {
      var url = this.host_api + '/transferencia/' + id + '/del';
      let params = {usuario_id: this.ss.getData('usuario_id')};
      let headers = new Headers({ 'Content-type': 'application/json' });
      headers.append('Authorization', "Bearer "+ this._token);
      headers.append('dbname', this.dbname);
      let options = new RequestOptions({ headers: headers });
  
      return this.http.put(url, params, options).map((res:Response) => {
        return this.config.onSuccessResponse(res);
      }).catch((error: any) => {
        return this.config.onErrorResponse(error);
      });
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/services/transferencias.service.ts